import React, { Component } from 'react';
import AsyncSelect from "react-select/async";
import ReactDOM from "react-dom";
import Table from "../MapaRevendaLocacao/Table";
import InnerLoading from "./InnerLoading";
import EmpreendimentoServiceCrawler from "../../services/empreendimentosServicesCrawler";
import tipos from "../MapaRevendaLocacao/tipos";
import { SelectButton } from "primereact/selectbutton";
import { InputNumber } from "primereact/inputnumber";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";

const RANGE_PRECO_VENDA = [
    { min: 0, max: 350000, id: '1', tipoRange: 'rangePreco' },
    { min: 350001, max: 500000, id: '2', tipoRange: 'rangePreco' },
    { min: 500001, max: 700000, id: '3', tipoRange: 'rangePreco' },
    { min: 700001, max: 1250000, id: '4', tipoRange: 'rangePreco' },
    { min: 1250001, max: 2000000, id: '5', tipoRange: 'rangePreco' },
    { min: 2000001, max: 4000000, id: '6', tipoRange: 'rangePreco' },
    { min: 4000001, max: 99999999, id: '19', tipoRange: 'rangePreco' },
];

const RANGE_PRECO_LOCACAO = [
    { min: 0, max: 1000, id: '1', tipoRange: 'rangePrecoLocacao' },
    { min: 1001, max: 2000, id: '2', tipoRange: 'rangePrecoLocacao' },
    { min: 2001, max: 3000, id: '3', tipoRange: 'rangePrecoLocacao' },
    { min: 3001, max: 5000, id: '4', tipoRange: 'rangePrecoLocacao' },
    { min: 5001, max: 8000, id: '5', tipoRange: 'rangePrecoLocacao' },
    { min: 8001, max: 10000, id: '6', tipoRange: 'rangePrecoLocacao' },
    { min: 10001, max: 99999999, id: '19', tipoRange: 'rangePrecoLocacao' },
];

const RANGE_PRECO_METRO_UTIL_VENDA = [
    { min: 0, max: 7000, id: '13', tipoRange: 'rangePrecoMetroUtil' },
    { min: 7001, max: 9000, id: '14', tipoRange: 'rangePrecoMetroUtil' },
    { min: 9001, max: 11000, id: '15', tipoRange: 'rangePrecoMetroUtil' },
    { min: 11001, max: 13000, id: '16', tipoRange: 'rangePrecoMetroUtil' },
    { min: 13001, max: 15000, id: '17', tipoRange: 'rangePrecoMetroUtil' },
    { min: 15001, max: 17000, id: '18', tipoRange: 'rangePrecoMetroUtil' },
    { min: 17001, max: 99999999, id: '21', tipoRange: 'rangePrecoMetroUtil' },
];

const RANGE_PRECO_METRO_UTIL_LOCACAO = [
    { min: 0, max: 70, id: '13', tipoRange: 'rangePrecoMetroUtilLocacao' },
    { min: 70.01, max: 90, id: '14', tipoRange: 'rangePrecoMetroUtilLocacao' },
    { min: 90.01, max: 110, id: '15', tipoRange: 'rangePrecoMetroUtilLocacao' },
    { min: 110.01, max: 130, id: '16', tipoRange: 'rangePrecoMetroUtilLocacao' },
    { min: 130.01, max: 150, id: '17', tipoRange: 'rangePrecoMetroUtilLocacao' },
    { min: 150.01, max: 170, id: '18', tipoRange: 'rangePrecoMetroUtilLocacao' },
    { min: 170.01, max: 99999999, id: '21', tipoRange: 'rangePrecoMetroUtilLocacao' },
];

class RelatorioRevendaLocacao extends Component {

    initialState = {
        //formulario
        cidade: '',
        tipo_negocio: '',
        tipo: [],
        bairros_options: [],
        bairros: [],
        quartos: [],
        padrao: [],
        vagas: [],
        area_maior_que: null,
        area_menor_que: null,
        valor_menor_que: null,
        valor_maior_que: null,
        valor_metro_maior_que: null,
        valor_metro_menor_que: null,

        //para ranges
        min: null,
        max: null,
        tipoRange: null,
        id: null,
        errorMessage: null,
        rangePreco: [...RANGE_PRECO_VENDA],
        rangePrecoLocacao: [...RANGE_PRECO_LOCACAO],
        rangeAreaUtil: [
            { min: 0, max: 50, id: '7', tipoRange: 'rangeAreaUtil' },
            { min: 51, max: 65, id: '8', tipoRange: 'rangeAreaUtil' },
            { min: 66, max: 80, id: '9', tipoRange: 'rangeAreaUtil' },
            { min: 81, max: 95, id: '10', tipoRange: 'rangeAreaUtil' },
            { min: 96, max: 150, id: '11', tipoRange: 'rangeAreaUtil' },
            { min: 151, max: 200, id: '12', tipoRange: 'rangeAreaUtil' },
            { min: 201, max: 99999999, id: '20', tipoRange: 'rangeAreaUtil' },

        ],
        rangePrecoMetroUtil: [...RANGE_PRECO_METRO_UTIL_VENDA],
        rangePrecoMetroUtilLocacao: [...RANGE_PRECO_METRO_UTIL_LOCACAO],

        loading: false,
        errors: {},
        query_id: '',
        show_mensagem: false,
        mensagem: '',

        //dados
        activeIndex: 0,
        count_buildings: 0,
        metadata: [],
        metadataQuartos: [],
        metadataPadrao: [],
        metadataRanges: [],

    }



    constructor() {
        super();
        this.state = this.initialState
        this.tipos = tipos.select_options;
        this.padroes = tipos.select_padroes;
    }

    cleanState = () => { this.setState({ ...this.initialState }) }

    quartos = [
        { label: '0Q', value: 0 },
        { label: '1Q', value: 1 },
        { label: '2Q', value: 2 },
        { label: '3Q', value: 3 },
        { label: '4Q', value: 4 },
    ];

    vagas = [
        { label: '1V', value: 1 },
        { label: '2V', value: 2 },
        { label: '3V', value: 3 },
        { label: '4V', value: 4 },

    ]

    searchCidade = async (inputQuery) => {
        if (inputQuery.length >= 2) {
            const response = await axios.get('/cidades/json-options-with-state-on-values/' + inputQuery);
            return response.data;
        }
    }

    fetchBairros = async (cidade) => {
        try {
            let bairros = await axios.get("/bairros-crawler/json/" + cidade);

            this.setState({ bairros_options: bairros.data })

        } catch (error) { console.log(error); }
    };

    changeRangeListByTipoNegocio = async (tipo_negocio) => {
        if (tipo_negocio === 'Aluguel') {
            this.setState({
                rangePreco: [...RANGE_PRECO_LOCACAO],
                rangePrecoMetroUtil: [...RANGE_PRECO_METRO_UTIL_LOCACAO]
            });
        } else {
            this.setState({
                rangePreco: [...RANGE_PRECO_VENDA],
                rangePrecoMetroUtil: [...RANGE_PRECO_METRO_UTIL_VENDA]
            });
        }
    }

    setLoading = (loading) => { this.setState({ loading: loading }); }

    submit = async () => {
        const formIsValid = await this.validateForm();

        if (!formIsValid) { return; }

        try {
            this.setState({
                loading: true,
                metadata: [],
                metadataQuartos: [],
                metadataPadrao: [],
                metadataRanges: [],
                errors: {},
            })

            const payloadGroupedByTipo = this.getPayload(["tipo"]);
            const payloadGroupedByTipoAndQuartos = this.getPayload(["tipo", "quartos"]);
            const payloadGroupedByTipoAndPadrao = this.getPayload(["tipo", "padrao"]);

            await Promise.all([
                this.getDataRange(payloadGroupedByTipo, "metadataPadrao"),
                this.getData(payloadGroupedByTipoAndQuartos, "metadataQuartos"),
                this.getData(payloadGroupedByTipoAndPadrao, "metadataPadrao"),
                this.getData(payloadGroupedByTipo, "metadata"),
            ]);

        } catch (e) {
            console.log(e);
        } finally {
            this.setLoading(false);
        }
    }

    getData = async (payload, metadata) => {

        let baseUrl = import.meta.env.VITE_API_MR_CRAWLER_URL;

        let response = await axios.post(`${baseUrl}api/imoveis-agregated`, payload)

        this.setState({
            [metadata]: response.data.data,
            count_buildings: response.data.data.reduce((accumulator, current) => {
                return accumulator + current.total
            }, 0),
            query_id: response.headers['x-query-id'],
            activeIndex: 1
        })
    }
    getDataRange = async (payload) => {

        let baseUrl = import.meta.env.VITE_API_MR_CRAWLER_URL;

        let response = await axios.post(`${baseUrl}api/imoveis-agregated-by-range`, payload)

        this.setState({ metadataRanges: response.data.data })
    }

    getPayload = (agrupamento) => {

        const cidade = this.state.cidade?.value?.split('-')[0];
        const estado = this.state.cidade?.value?.split('-')[1];
        const quartos = this.state.quartos.length > 0 ? this.state.quartos : [];
        const padrao = this.state.padrao.length > 0 ? this.state.padrao : [];

        return {
            cidade,
            estado,
            tipo: this.state.tipo,
            tipo_negocio: this.state.tipo_negocio,
            area_menor_que: this.state.area_menor_que,
            area_maior_que: this.state.area_maior_que,
            valor_menor_que: this.state.valor_menor_que,
            valor_maior_que: this.state.valor_maior_que,
            valor_metro_menor_que: this.state.valor_metro_menor_que,
            valor_metro_maior_que: this.state.valor_metro_maior_que,
            quartos: this.state.quartos,
            vagas: this.state.vagas,
            bairros: this.state.bairros,
            agrupamento: agrupamento,
            padrao: padrao,
            ranges: {
                // quartos: quartos,
                // padrao: padrao,
                preco: this.state.rangePreco.map((range) => [range.min, range.max]),
                area_util: this.state.rangeAreaUtil.map((range) => [range.min, range.max]),
                preco_metro_util: this.state.rangePrecoMetroUtil.map((range) => [range.min, range.max]),
            }
        };
    }

    requestExcel = async () => {
        try {
            let response = await EmpreendimentoServiceCrawler.exportExcel(this.state.query_id);

            this.setState({ show_mensagem: true, mensagem: response.data.message })

            window.scrollTo({ top: 0, behavior: 'smooth' });

        } catch (error) {
            console.log("Erro ao Buscar Empreendimento");
            console.log(error);
        }
    }

    validateRangeFields = () => {
        const { min, max, tipoRange } = this.state;

        if (min == null || max == null || tipoRange == null) {
            return "Preencha todos os campos";
        }

        if (typeof min !== 'number' || typeof max !== 'number') {
            return "Valores inválidos";
        }

        if (Number.isNaN(min) || Number.isNaN(max)) {
            return "Valores inválidos";
        }

        if (min < 0 || max < 0) {
            return "Não são permitidos valores negativos";
        }

        if (max < min) {
            return "Valor máximo deve ser maior que o mínimo";
        }

        return null;
    };

    isRangeDuplicate = (ranges, min, max, id) => {
        return ranges.some((range) => range.min === min && range.max === max && range.id !== id);
    };

    isRangeOverlapping = (ranges, min, max, id) => {
        return ranges.some(
            (range) =>
                range.id !== id &&
                (
                    (min >= range.min && min <= range.max) ||
                    (max >= range.min && max <= range.max) ||
                    (min <= range.min && max >= range.max)
                )
        );
    };

    handleAddOrUpdateRange = async () => {

        const { tipoRange, min, max, id } = this.state;

        const ranges = this.state[tipoRange] || [];

        const validationError = this.validateRangeFields();

        if (validationError) {
            return this.setState({ errorMessage: validationError })
        };

        if (this.isRangeDuplicate(ranges, min, max, id)) {
            return this.setState({ errorMessage: "Já existe um range com esses valores" });
        }

        if (this.isRangeOverlapping(ranges, min, max, id)) {
            return this.setState({ errorMessage: "O range se sobrepõe a outro range" });
        }

        const newRange = { min, max, tipoRange, id: id ?? this.generateRandomString(), };

        if (id) {
            this.updateRange(newRange);
        } else {
            this.addRange(newRange);
        }
        this.setState({ min: null, max: null, id: null, errorMessage: null, tipoRange: null });
    }

    addRange = (range) => {
        const { tipoRange } = this.state;
        const updatedRanges = [...this.state[tipoRange], range].sort((a, b) => a.min - b.min);

        this.setState({ [tipoRange]: updatedRanges });
    };

    updateRange = (range) => {
        const { tipoRange } = this.state;
        const updatedRanges = this.state[tipoRange].map((r) => r.id === range.id ? { ...r, ...range } : r).sort((a, b) => a.min - b.min);
        this.setState({ [tipoRange]: updatedRanges });
    };

    handleRemoveRange = (tipoRange, index) => {
        this.setState((prevState) => {
            const updatedRange = [...prevState[tipoRange]];
            updatedRange.splice(index, 1);
            return { [tipoRange]: updatedRange };
        });
    };

    generateRandomString = () => {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }

    render() {
        return (
            <React.Fragment>
                {this.state.show_mensagem && <>
                    <div className="row">
                        <div className="col-12">
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                <strong>Sucesso!</strong> {this.state.mensagem}
                                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </>}
                <Accordion activeIndex={this.state.activeIndex}
                    onTabChange={(e) => this.setState({ activeIndex: e.index })}>
                    <AccordionTab header={"Formulário"}>
                        <div>
                            {this.state.loading && <InnerLoading />}
                            <div className="form-group row">

                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="">Cidade</label>
                                    <AsyncSelect
                                        cacheOptions
                                        isClearable
                                        noOptionsMessage={() => 'Nenhum Resultado'}
                                        placeholder="Digite para buscar..."
                                        value={this.state.cidade}
                                        loadOptions={this.searchCidade}
                                        onChange={async (e) => {
                                            this.setState({ cidade: e });

                                            await this.fetchBairros(e.value.split('-')[0]);
                                        }}
                                    />
                                    {this.state.errors['cidade'] && <>
                                        <span className="invalid-feedback d-block" role="alert">
                                            <strong>{this.state.errors['cidade']}</strong>
                                        </span>
                                    </>}
                                </div>

                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="">Bairro</label>
                                    <MultiSelect
                                        maxSelectedLabels={3}
                                        filter={true}
                                        style={{ width: '100%' }}
                                        display="chip"
                                        optionLabel="label"
                                        value={this.state.bairros}
                                        options={this.state.bairros_options}
                                        appendTo={document.body}
                                        onChange={(e) => this.setState({ bairros: e.value })}
                                    />

                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="tipo">Tipo</label><br />
                                    <MultiSelect
                                        maxSelectedLabels={3}
                                        filter={true}
                                        style={{ width: '100%' }}
                                        display="chip"
                                        optionLabel="label"
                                        value={this.state.tipo}
                                        options={this.tipos}
                                        appendTo={document.body}
                                        onChange={(e) => this.setState({ tipo: e.value })}
                                    />
                                </div>

                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="">Tipo de Negócio</label>
                                    <Dropdown
                                        value={this.state.tipo_negocio}
                                        options={[
                                            { label: 'Selecione', value: '' },
                                            { label: 'Revenda', value: 'Venda' },
                                            { label: 'Locação', value: 'Aluguel' },
                                        ]}
                                        onChange={async (e) => {
                                            this.setState({ tipo_negocio: e.value, });
                                            await this.changeRangeListByTipoNegocio(e.value);
                                        }}
                                        placeholder="Selecione"
                                        style={{ width: '100%' }}
                                    />

                                    {this.state.errors['tipo_negocio'] && <>
                                        <span className="invalid-feedback d-block" role="alert">
                                            <strong>{this.state.errors['tipo_negocio']}</strong>
                                        </span>
                                    </>}
                                </div>

                            </div>

                            <div className="form-group row">
                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="tipo">Quartos</label><br />
                                    <SelectButton
                                        optionLabel="label"
                                        optionValue="value"
                                        multiple={true}
                                        value={this.state.quartos}
                                        options={this.quartos}
                                        itemTemplate={(option) => {
                                            return <React.Fragment><i className="fa fa-bed"></i> &nbsp; {option.label}
                                            </React.Fragment>
                                        }}
                                        onChange={(e) => this.setState({ quartos: e.value })}
                                    />
                                </div>

                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="tipo">Vagas</label><br />
                                    <SelectButton
                                        optionLabel="label"
                                        optionValue="value"
                                        multiple={true}
                                        value={this.state.vagas}
                                        options={this.vagas}
                                        style={{ width: '100%' }}
                                        itemTemplate={(option) => {
                                            return <React.Fragment><i className="fa fa-car"></i> &nbsp; {option.label}
                                            </React.Fragment>
                                        }}
                                        onChange={(e) => this.setState({ vagas: e.value })}
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="tipo">Área Mínima</label><br />
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        mode="decimal" minFractionDigits={2} maxFracionDigits={2}
                                        value={this.state.area_maior_que}
                                        locale="pt-BR"
                                        onValueChange={(e) => this.setState({ area_maior_que: e.value })}
                                    />
                                </div>

                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="">Área Máxima</label><br />
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        mode="decimal" minFractionDigits={2} maxFracionDigits={2}
                                        locale="pt-BR"
                                        value={this.state.area_menor_que}
                                        onValueChange={(e) => this.setState({ area_menor_que: e.value })}
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="tipo">Valor Mínimo</label><br />
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        mode="decimal" minFractionDigits={2} maxFracionDigits={2}
                                        value={this.state.valor_maior_que}
                                        locale="pt-BR"
                                        onValueChange={(e) => this.setState({ valor_maior_que: e.value })}
                                    />
                                </div>

                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="">Valor Máximo</label><br />
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        mode="decimal" minFractionDigits={2} maxFracionDigits={2}
                                        locale="pt-BR"
                                        value={this.state.valor_menor_que}
                                        onValueChange={(e) => this.setState({ valor_menor_que: e.value })}
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="tipo">Valor Metro Mínimo</label><br />
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        mode="decimal" minFractionDigits={2} maxFracionDigits={2}
                                        value={this.state.valor_metro_maior_que}
                                        locale="pt-BR"
                                        onValueChange={(e) => this.setState({ valor_metro_maior_que: e.value })}
                                    />
                                </div>

                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="">Valor Metro Máximo</label><br />
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        mode="decimal" minFractionDigits={2} maxFracionDigits={2}
                                        locale="pt-BR"
                                        value={this.state.valor_metro_menor_que}
                                        onValueChange={(e) => this.setState({ valor_metro_menor_que: e.value })}
                                    />
                                </div>
                            </div>

                            <div className='form-group row'>
                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="padrao">Padrão</label><br />
                                    <MultiSelect
                                        maxSelectedLabels={3}
                                        filter={true}
                                        style={{ width: '100%' }}
                                        display="chip"
                                        optionLabel="label"
                                        value={this.state.padrao}
                                        options={this.padroes}
                                        appendTo={document.body}
                                        onChange={(e) => this.setState({ padrao: e.value })}
                                    />
                                </div>
                            </div>
                            <div className='form-group row'>
                                <div className="col-12 col-md-12 col-sm-12 col-lg-12">
                                    <label>Range Por:</label>
                                    <Dropdown
                                        value={this.state.tipoRange}
                                        options={[
                                            { value: 'rangePreco', label: 'Preço' },
                                            { value: 'rangeAreaUtil', label: 'Área Privativa' },
                                            { value: 'rangePrecoMetroUtil', label: 'Preço metro Privativo' },
                                        ]}
                                        onChange={async (e) => await this.setState({ tipoRange: e.value })}
                                        optionLabel="label"
                                        placeholder="Selecione um tipo"
                                        style={{ width: '100%' }}
                                    />
                                </div>

                                <div className="col-12 col-md-6 col-sm-6 col-lg-6">
                                    <label>A partir de</label>
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        mode="decimal" minFractionDigits={2} maxFracionDigits={2}
                                        value={this.state.min}
                                        locale="pt-BR"
                                        onValueChange={async (e) => await this.setState({ min: e.value })}
                                    />
                                </div>

                                <div className="col-12 col-md-6 col-sm-6 col-lg-6">
                                    <label>Até</label>
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        mode="decimal" minFractionDigits={2} maxFracionDigits={2}
                                        value={this.state.max}
                                        locale="pt-BR"
                                        onValueChange={async (e) => await this.setState({ max: e.value })}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    {this.state.errorMessage &&
                                        <div className="alert alert-danger" role="alert">
                                            {this.state.errorMessage}
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-12 col-md-4 col-sm-4">
                                    <button
                                        disabled={this.state.loading}
                                        className="btn btn-sm btn-primary btn-block"
                                        onClick={this.handleAddOrUpdateRange}
                                    >
                                        {this.state.id == null ? 'Adicionar' : 'Atualizar'} Range
                                    </button>
                                </div>
                                <div className="col-12 col-md-4 col-sm-4">
                                    <button disabled={this.state.loading} className="btn btn-sm btn-success btn-block"
                                        onClick={this.submit}>
                                        Gerar Relatório
                                    </button>
                                </div>

                                <div className="col-12 col-md-4 col-sm-4">
                                    <button disabled={this.state.loading} className="btn btn-sm btn-danger btn-block"
                                        onClick={this.cleanState}>
                                        Limpar
                                    </button>
                                </div>
                            </div>
                        </div>
                        {(
                            this.state.rangePreco.length > 0 ||
                            this.state.rangeAreaUtil.length > 0 ||
                            this.state.rangePrecoMetroUtil.length > 0
                        ) && (
                                <div className="col-12">
                                    <div style={{ height: '250px', overflowY: 'scroll' }}>
                                        <label>Ranges</label>
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>A partir de</th>
                                                    <th>Até</th>
                                                    <th>Tipo</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[
                                                    { data: this.state.rangePreco, label: 'Preço', tipoRange: "rangePreco" },
                                                    { data: this.state.rangeAreaUtil, label: 'Área Privativa', tipoRange: "rangeAreaUtil" },
                                                    { data: this.state.rangePrecoMetroUtil, label: 'Preço metro Privativo', tipoRange: "rangePrecoMetroUtil" },
                                                ].flatMap(({ data, label, tipoRange }) =>
                                                    data.map((range, index) => (
                                                        <tr key={`${label}-${index}`}>
                                                            <td>{(range.max == 99999999 ? "Acima de " : "") + Number(range.min).toLocaleString()}</td>
                                                            <td>{range.max == 99999999 ? "" :  Number(range.max).toLocaleString()}</td>
                                                            <td>{label}</td>
                                                            <td>
                                                                <td>
                                                                    <button className="btn btn-xs btn-danger btn-sm"
                                                                        onClick={() => this.handleRemoveRange(tipoRange, index)}>
                                                                        <i className="fa fa-trash"></i>
                                                                    </button>
                                                                    <button className="btn btn-xs btn-danger btn-sm"
                                                                        onClick={() => this.setState({
                                                                            min: range.min,
                                                                            max: range.max,
                                                                            tipoRange: tipoRange,
                                                                            id: range.id
                                                                        })}>
                                                                        <i className="fa fa-pen"></i>
                                                                    </button>
                                                                </td>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                    </AccordionTab>
                    <AccordionTab header={"Resultado"}>
                        <div>
                            {
                                this.state.metadata.length > 0 && !this.state.loading && <>
                                    <React.Fragment>
                                        <Table
                                            title={this.state.tipo_negocio}
                                            metadata={this.state.metadata}
                                            metadataQuartos={this.state.metadataQuartos}
                                            metadataPadrao={this.state.metadataPadrao}
                                            metadataRanges={this.state.metadataRanges}
                                            count_buildings={this.state.count_buildings}
                                            color={'#1e78b4'}
                                        />
                                        <hr />

                                        {window.canExportRevendaLocacao && (
                                            <div className="d-flex justify-content-end mb-2" style={{ alignItems: 'flex-start' }}>
                                                <button className="btn btn-sm btn-success" onClick={this.requestExcel}>
                                                    <i className="fa fa-file-excel-o"></i> &nbsp;
                                                    Exportar Excel dos Imóveis
                                                </button>
                                            </div>
                                        )}

                                    </React.Fragment>

                                </>
                            }
                        </div>
                    </AccordionTab>
                </Accordion>
                <hr />


            </React.Fragment>
        )
            ;
    }

    validateForm = async () => {
        let errors = {};
        //cidade e estado e tipo de negocio são requeridos
        if (!this.state.cidade || this.state.cidade === '') {
            errors['cidade'] = 'O campo cidade é requerido'
        }

        if (!this.state.tipo_negocio || this.state.tipo_negocio === '') {
            errors['tipo_negocio'] = 'O campo Tipo Negócio é requerido'
        }

        if (Object.keys(errors).length > 0) {
            await this.setState({
                ...this.state,
                errors: errors
            })

            return false;
        }

        return true;
    }
}

if (document.getElementById('relatorioRevendaLocacao')) {
    ReactDOM.render(<RelatorioRevendaLocacao />, document.getElementById('relatorioRevendaLocacao'));
}
